import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'does_the_fac_have_any_of_the_following_safety_measures_in_place_14'

export const dataPointDefinition = {
  retracedId: 'does_the_fac_have_any_of_the_following_safety_measures_in_place_14',
  name: 'Does the facility have any of the following safety measures in place related to extreme hot or cold environments?',
  description:
    'Heat or cold related stress can occur when the body is unable to warm or cool itself. Heat stress results from a combination of (1) internal body heat production from doing work and (2) external heat exposure from the environment. Cold stress results from being exposed to extreme cold or working in cold environments. Heat and cold stress can contribute to adverse health effects.',
  meta: {},
  fieldTypeId: 'CHECK_BOX',
  type: 'RELATIONAL',
  options: [
    {
      key: 'THE_FACILITY_HAS_PERFORMED_A_RISK_ASSESSMENT_OF_WHERE_HEAT_OR_C',
      text: 'The facility has performed a risk assessment of where heat or cold exposure may be significant',
      externalIds: [
        {
          id: 'hs-34--1-1x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'SHIELDS_ARE_IN_PLACE_TO_PROTECT_WORKERS_FROM_RADIANT_HEAT_SOURC',
      text: 'Shields are in place to protect workers from radiant heat sources',
      externalIds: [
        {
          id: 'hs-34--1-3x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'WORKERS_WHO_ARE_EXPOSED_TO_HEAT_RADIATION_ARE_GIVEN_REST_BREAKS',
      text: 'Workers who are exposed to heat/radiation are given rest breaks and/or rotations',
      externalIds: [
        {
          id: 'hs-34--1-4x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'FACILITY_HAS_IMPLEMENTED_BASIC_MEDICAL_SURVEILLANCE_TECHNIQUES_',
      text: 'Facility has implemented basic medical surveillance techniques to monitor workers who are exposed to heat/cold sources',
      externalIds: [
        {
          id: 'hs-34--1-5x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
    {
      key: 'NONE_OF_THE_ABOVE',
      text: 'None of the above',
      externalIds: [
        {
          id: 'hs-34--1-6x',
          version: '1.6.0',
          provider: 'slcp',
        },
      ],
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'array',
        items: {
          type: 'object',
          properties: {
            key: {
              type: 'string',
              enum: [
                'THE_FACILITY_HAS_PERFORMED_A_RISK_ASSESSMENT_OF_WHERE_HEAT_OR_C',
                'SHIELDS_ARE_IN_PLACE_TO_PROTECT_WORKERS_FROM_RADIANT_HEAT_SOURC',
                'WORKERS_WHO_ARE_EXPOSED_TO_HEAT_RADIATION_ARE_GIVEN_REST_BREAKS',
                'FACILITY_HAS_IMPLEMENTED_BASIC_MEDICAL_SURVEILLANCE_TECHNIQUES_',
                'NONE_OF_THE_ABOVE',
              ],
            },
            isChecked: {
              type: 'boolean',
            },
            followUp: {
              type: ['object', 'null'],
              properties: {
                value: {
                  type: 'string',
                },
              },
              required: ['value'],
            },
          },
          required: ['key', 'isChecked', 'followUp'],
        },
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-wor-6',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 16230,
  sectionId: '2.2.9.7',
  impactArea: 'Worker Protection',
  impactAreaId: 'WORKER_PROTECTION',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
